const normalizeHireApiBase = (base) => {
  if (!base) return ''
  return base.endsWith('/') ? base : `${base}/`
}

export const getSsoLoginUrl = () => {
  const base = normalizeHireApiBase(process.env.VUE_APP_HIRE_API || '')
  return `${base}v1/auth/sso/login`
}

export const redirectToSsoLogin = () => {
  window.location.assign(getSsoLoginUrl())
}

export const getSsoAdminConsentUrl = (tenantId, returnUrl) => {
  const base = normalizeHireApiBase(process.env.VUE_APP_HIRE_API || '')
  let url = `${base}v1/auth/sso/admin-consent?tenant_id=${encodeURIComponent(tenantId)}`

  if (returnUrl) {
    url += `&return_url=${encodeURIComponent(returnUrl)}`
  }

  return url
}

export const redirectToSsoAdminConsent = (tenantId) => {
  const returnUrl = `${window.location.origin}${window.location.pathname}`
  window.location.assign(getSsoAdminConsentUrl(tenantId, returnUrl))
}

export const isSsoEnforcedForEmail = (store, email) => {
  if (!email) return Promise.resolve(false)

  return store.dispatch('attemptDiscoverSso', { email })
    .then((data) => data.ssoEnabled === true || data.enforced === true)
    .catch(() => false)
}

export const applySsoHandoff = ({ token, subdomain }) => {
  if (!token) return false

  let storage = {}
  try {
    storage = JSON.parse(window.localStorage.getItem('plooral-global') || '{}')
  } catch (e) {
    storage = {}
  }

  storage.token = token
  window.localStorage.setItem('plooral-global', JSON.stringify(storage))

  if (subdomain) {
    window.location.replace(`/c/${encodeURIComponent(subdomain)}/hire/dashboard/home`)
  } else {
    window.location.replace('/')
  }

  return true
}

export const ssoHandoffBeforeEnter = (to, from, next) => {
  if (applySsoHandoff({ token: to.query.token, subdomain: to.query.subdomain })) {
    return
  }
  next({ name: 'auth.login.corporate' })
}
